// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://apihr.elguajirito.com/api/',
  imageUrl: 'https://apihr.elguajirito.com/api/',
  // apiUrl: 'http://localhost:5000/api/',
  // imageUrl: 'http://localhost:5000/',
  // apiUrl: 'https://api.hr.elguajirito.com/api/',
  // imageUrl: 'https://api.hr.elguajirito.com/',
  defaultLanguage: 'es'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
